import { RESUME_REQUIREMENT_ID } from "@src/appV2/redesign/PlacementCandidate/components/PlacementCandidateOnboarding/ResumeCard";
import type { UseModalState } from "@src/appV2/redesign/system/ui-components";
import { generatePath, useHistory } from "react-router-dom";

import {
  DOCUMENT_CAMERA_PERMISSION_ERROR_PATH,
  DOCUMENT_DETAILS_FULL_PATH,
  DOCUMENT_PREVIEW_FULL_PATH,
} from "../../paths";
import { useFileUploaderContext } from "../../useFileUploaderContext";
import { FileSelectionBottomSheet } from "../components/FileSelectionBottomSheet";
import { useRequirementDetailsContext } from "../useRequirementDetailsContext";

const DOCUMENT_CONTENT_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
];

const BASE_CONTENT_TYPES = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];

interface DocumentUploadBottomSheetProps {
  modalState: UseModalState;
}

export function DocumentDetailsUploadBottomSheet(props: DocumentUploadBottomSheetProps) {
  const { modalState } = props;

  const { requirement } = useRequirementDetailsContext();
  const { addFile } = useFileUploaderContext();
  const history = useHistory();

  const contentTypes = [
    ...(requirement?.requirementId === RESUME_REQUIREMENT_ID ? DOCUMENT_CONTENT_TYPES : []),
    ...BASE_CONTENT_TYPES,
  ];

  const navigateToPreview = () => {
    history.replace(
      generatePath(DOCUMENT_PREVIEW_FULL_PATH, { requirementId: requirement.requirementId })
    );
  };

  return (
    <FileSelectionBottomSheet
      modalState={modalState}
      contentTypes={contentTypes}
      onFileAdded={(file) => {
        addFile(file);
        navigateToPreview();
      }}
      onFilesAdded={(files) => {
        for (const file of files) {
          addFile(file);
        }

        navigateToPreview();
      }}
      onCameraPermissionDenied={() => {
        history.replace(
          generatePath(`${DOCUMENT_DETAILS_FULL_PATH}/${DOCUMENT_CAMERA_PERMISSION_ERROR_PATH}`, {
            requirementId: requirement.requirementId,
          })
        );
      }}
    />
  );
}
